export default {
  en: {
    closed: 'Voting is closed',
    clear_votes: 'Clear my votes',
    no_total: 'No members voted',
    total: {
      zero: 'Vote now!',
      one: '1 member voted',
      other: '%{count} members voted',
    },
  },
};
